import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const initializeI18n = async (namespace: string) => {
  // Fetch the custom (namespace) translations
  const customResponse = await fetch(`/locales/fr/${namespace}.json`);
  const customTranslations = await customResponse.json();

  // Fetch the common translations
  const commonResponse = await fetch('/locales/fr/common.json');
  const commonTranslations = await commonResponse.json();

  return i18n.use(initReactI18next).init({
    // Provide all relevant translations under the same language ('fr')
    resources: {
      fr: {
        [namespace]: customTranslations,
        common: commonTranslations,
      },
    },
    lng: 'fr', // Default language
    fallbackLng: 'fr', // Fallback language if needed
    ns: [namespace, 'common'], // List both namespaces you’ll use
    defaultNS: namespace, // Primary namespace
    fallbackNS: 'common', // Fallback to 'common' if key not found
    interpolation: {
      escapeValue: false, // React does escaping by default
    },
  });
};

export default initializeI18n;
